import React, { useEffect, useRef } from 'react';
import useState from 'react-usestateref';
import '../index.css';
import Navbar from '../components/Navbar.js';
import Spinner from '../Spinner.js';
import {
    getLog, querySqlRustService,wrietSqlResultToFile,copyFile,updateConnection,
    loadFile, readEachConnection, readFiles, readEachReportData,
    listOfFileNamesPageDir,getAuthHeader,generateSqlWithAgentAi
} from '../authorization/FetchToken.js';
import { useNavigate } from 'react-router-dom'; 
import debounce from "lodash.debounce";
import ErrorDialog from "../grid/ErrorDialog.js"
import ApplyFunctionsDialog from "../grid/ApplyFunctionsDialog.js"

import {
  FormControl,
  InputLabel,
} from "@mui/material";
import { Button } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useAuth } from './AuthContext';
import InfoTip from "../components/InfoTip";
import CloseIcon from "@mui/icons-material/Close";
import ReactMarkdown from "react-markdown";
import Drawer from "@mui/material/Drawer";
import { IconButton,Box} from "@mui/material";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Close from "@mui/icons-material/Close";


function ApplyFunctionsPage() {
    const connectionType = 'SQLite';
    let llmInitConName='';
    let schemasList = [];
    let tableList = [];
    let columnList = [];
    let colList = [];
    let columnTypeList = [];
    let partitionByValue;
    let orderByValue;
    let selectedTableColumnsValue = [];
    //let connectionName = "kafka_test_5";
    const [messages, setMessages,ref] = useState([]);
    const [inputMessage, setInputMessage] = useState('');
    const [loading, setLoading] = useState(false);

    //const [catalog, setCatalog] = useState('');
    const [selectedDatabase, setSelectedDatabase] = useState('');
    const [selectedTable, setSelectedTable] = useState('');
    const [leftList, setLeftList] = useState([]);
    const [rightList, setRightList] = useState([]);
    const [tableDataList, setTableDataList] = useState(tableList.length > 0 ? tableList : []);
    const [columnDataList, setColumnDataList] = useState(columnList.length > 0 ? columnList : []);
    const [selectedTableColumns, setSelectedTableColumns] = useState(
        selectedTableColumnsValue && selectedTableColumnsValue.length > 0 ? selectedTableColumnsValue : ' ');
    const [orderBy, setOrderBy] = useState(
        orderByValue && orderByValue.length > 0 ? orderByValue : ' ');
    const [partitionBy, setPartitionBy] = useState(
        partitionByValue && partitionByValue.length > 0 ? partitionByValue : ' ');
    const [columnTypeListValue, setColumnTypeListValue] = useState(columnTypeList.length > 0 ? columnTypeList : []);
    const [selectedCells, setSelectedCells] = useState([]);
    const [jsonCopy, setJsonCopy,jsonCopyRef] = useState({});
    const [catalogCopy, setCatalogCopy] = useState();
    const[url, setUrl] = useState('');
    const [key, setKey] = useState('');
    //const [model, setModel] = useState('');

    const [model, setModel] = useState("gpt-4o-mini"); 
    const [apiKey, setApiKey] = useState("");
    const [showKey, setShowKey] = useState(false);
  const { userSessionRef} = useAuth();
   const [loggedInUserRole,setloggedInUserRole] = useState("")


    const [temperature, setTemperature] = useState('');
    //const [role, setRole] = useState('user');
    const [llmConnectionName, setLlmConnectionName,llName] = useState();
    const [selectedLlmConnectionName, setSelectedLlmConnectionName] = useState('');
    const [llmData, setLlmData] = useState([]);
    const [jsonData, setJsonData] = useState([]);
    const [modelVendor, setModelVendor] = useState('openapi');
    const [jsonError, setJsonError] = useState('');
    const navigate = useNavigate();
    const [apiError, setApiError,apiErrorRef] = useState('');
    const [llmResp, setLlmResp,llmRespRef] = useState('');
    const [fileType, setFileType] = useState('csv');
    const [loadFileType, setLoadFileType] = useState('csv');
    const [fileName, setFileName,fileNameRef,] = useState("");
    //const [queryDescription, setQueryDescription] = useState("");
    const [queryDescription, setQueryDescription] = useState(() => {
      return localStorage.getItem("queryDesc") || "";
    });
    let json = {};
    let catalog;
    let currentTableName;
    let userName;
    let selectedTableName;

  const [selectedNodeId, setSelectedNodeId] = useState(null);


  const [sqlDirectQuery, setSqlDirectQuery] = useState();

  const [error, setError] = useState(''); // Error message state
  const [showErrorPopup, setShowErrorPopup] = useState(false); // Error popup visibility state
  const [gridData, setGridData] = useState([]);
  const [value, setValue,valueRef] = useState('');
  const editorRef = useRef(null);
  let execSqlStatement = false;
  const [isResultModalOpen, setIsResultModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [funcColsCreateContent,  setFuncColsCreateContent,funcColsCreateContentRef] = useState([]);
  const [selectedColumn, setSelectedColumn,selectedColumnRef] = useState('');
  const [activeColumn, setActiveColumn,activeColumnRef] = useState(null);
  const [functionPanelOpen, setFunctionPanelOpen] = useState(false);
  const [selectedFunction, setSelectedFunction,selectedFunctionRef] = useState("");
  const [selectedFunctionGroup, setSelectedFunctionGroup,selectedFunctionGroupRef] = useState("");
  const [selectedNewColumn, setSelectedNewColumn,selectedNewColumnRef] = useState("");
  const [columnTransforms, setColumnTransforms,columnTransformsRef] = useState({});
  const [transformations, setTransformations] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartCol, setDragStartCol] = useState(null);
  const colIndex = (col) => resultCols.indexOf(col);
  const [fileDir, setfileDir,fileDirRef] = useState([]);
  const [feature, setFeature,featureRef] = useState("files");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [dragSelecting, setDragSelecting] = useState([]);
  const [applyMode, setApplyMode] = useState("");
  const [newColumnName, setNewColumnName,newColumnNameRef] = useState("");
  const [funcUDFContent, setFuncUDFContent,funcUDFContentRef] = useState([]);
  const [funcStandardContent, setFuncStandardContent,funcStandardContentRef] = useState([]);
  const [funcCarbonContent, setFuncCarbonContent,funcCarbonContentRef] = useState([]);
  const [funcSqliteContent, setFuncSqliteContent,funcSqliteContentRef] = useState([]);
  const [funcGroupContent, setGroupContent,funcGroupContentRef] = useState([]);
  const [funcSearch, setFuncSearch,funcSearchRef] = useState("");
  const [openGroup, setOpenGroup] = useState(""); // or "udf"
  const [isFuncOpen, setIsFuncOpen] = useState(false);
  const [showApplyPreview, setShowApplyPreview,showApplyPreviewRef] = useState(false);
  const [extraArgsOpen, setExtraArgsOpen,extraArgsOpenRef] = useState(false);
  const [argsByColumn, setArgsByColumn,argsByColumnRef] = useState({});
  const [extraArgsOpenFor, setExtraArgsOpenFor] = useState(null);
  const [groupByColumn, setGroupByColumn] = useState([]);
  const [extraArgs, setExtraArgs] = useState([
    { type: "column", value: "" }, // first extra argument
  ]);
  const [allColumns, setAllColumns] = useState([]);
  const [authHeader,setAuthHeader, authHeaderRef] = useState([]);
  const [openDoc, setOpenDoc] = useState(false);
  const [doc, setDoc] = useState("");
  const [quotaMessage, setQuotaMessage] = useState(false);
  const INVERTIBLE_MANAGED_ORG = "invertible_managed";

useEffect(() => {
  if (!userSessionRef) return;
    //fetchListDataConnections();
    getUploadedFiles();
}, [userSessionRef]);
  
  useEffect(() => {
    if (!userSessionRef) return;
  }, [leftList,userSessionRef]);


const defaultAdvancedJson = JSON.stringify({
    temperature:"",
    top_p: "",
    max_tokens: "",
    do_sample: "",
    stop: [""]
}, "", 2);

const [advancedParamsJson, setAdvancedParamsJson] = useState(defaultAdvancedJson);
const [selectedFilePath,setSelectedFilePath,selectedFilePathRef] = useState('');
const [dataFiles, setDataFiles] = useState([]);
const [firstFolderName, setFirstFolderName] = useState('');
const [generatedSql, setGeneratedSql] = useState("");
const [useSql, setUseSql] = useState(false);


function AlertBanner({ message, onClose }) {
        if (!message) return null;
      
        return (
          <div style={{
            backgroundColor: '#fdecea',
            color: '#611a15',
            padding: '10px 20px',
            border: '1px solid #f5c6cb',
            borderRadius: '5px',
            marginBottom: '1rem',
            position: 'relative'
          }}>
            <span>{message}</span>
            <button
              onClick={onClose}
              style={{
                position: 'absolute',
                top: '5px',
                right: '10px',
                background: 'none',
                border: 'none',
                fontSize: '16px',
                color: '#611a15',
                cursor: 'pointer'
              }}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        );
      }

  const [sqlQuery, setSqlQuery] = useState('');
  const [resultRows, setResultRows,resultRowsRef] = useState([]);
  const [resultCols, setResultCols] = useState([]);
  const [sqlDrawerOpen, setSqlDrawerOpen] = useState(false);

  // Restore last SQL query from localStorage
  useEffect(() => {
    if (!userSessionRef) return;
    const saved = localStorage.getItem('last_sql_query');
    if (saved) setSqlQuery(saved);
  }, [userSessionRef]);

const handleExecuteRust = async (database,query) => {
    console.log('handleExecuteRust::1.5');
    setLoading(true);
    try {
      //const token = await fetchToken();
      let org = userSessionRef.current["orgName"];
      if (userSessionRef.current["orgName"]==INVERTIBLE_MANAGED_ORG){
          org = userSessionRef.current["orgName"] + "`" + userSessionRef.current["userName"];
      }

      const cpFuntionsFile = await copyFile("/home/stateFiles/" + userSessionRef.current["orgName"] + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/functions/functions" , `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DATA_DIR}` + "functions/functions",userSessionRef.current["orgName"])
      const json = await querySqlRustService(database, query,userSessionRef.current["userName"],org);
      console.log('handleExecuteRust::11',json);
      if (typeof json === "string") {
        if (json.toLowerCase().includes("quota")) {
          setQuotaMessage(true);
          setErrorMessage(json);
          setShowErrorMessage(true);
          return;
        }
    }
      const data = json.results;
      //console.log('handleExecuteRust::112', JSON.stringify(data));
      if (!Array.isArray(data) || data.length < 1) {
        throw new Error("Empty or invalid result from Rust SQL engine");
      }
  
      // First row is header
      const [columns, ...rows] = data;
      console.log('handleExecuteRust::raw output::2', columns);
  
      // Use in React Table
      setResultCols(columns);  // ['col1', 'col2', ...]
      setResultRows(rows);     // [['val1', 'val2', ...], ...]
  
    } catch (err) {
      setResultCols([]);
      setResultRows([]);
    } finally {
      setLoading(false);
    }
  };

const handleRefreshData= async (query) => {
  const userName = userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '')
  const dataFile = selectedFilePathRef.current.split('/').pop();
  const org_name = userSessionRef.current["orgName"] + "/users/" + userName+ "/" + dataFile
  handleExecuteRust(`${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org_name + "/databases/_invertible_database",query);
}

//const funcsColMap ={"udf":funcUDFContentRef.current,"standard":funcStandardContentRef.current,"carbon":funcCarbonContentRef.current,"sqlite":funcSqliteContentRef.current}
function getCreateCols(fnName, group) {
  const funcsColMap ={"udf":funcUDFContentRef.current,"standard":funcStandardContentRef.current,"carbon":funcCarbonContentRef.current,"sqlite":funcSqliteContentRef.current,"group":funcCarbonContentRef.current}
  const list = funcsColMap[group];
  console.log("Cols::11",list,funcsColMap,group)
  if (!Array.isArray(list)) return null;

  const found = list.find(fn => fn.name === fnName || fn.fn === fnName);
  if (!found) return null;

  return found.create_cols || null;
}

const checkResponse = (resp) => {
  if (!resp) {
    return false;
  }

  if (typeof resp === "string") {
    if (
      resp.toLowerCase().includes("quota")
    ) {
      setQuotaMessage(true);
      setErrorMessage(resp);
      setShowErrorMessage(true);
      return true;
    }

    return false;
  }

  if (
    resp.error !== undefined &&
    resp.error !== null
  ) {
    const error =
      typeof resp.error === "string"
        ? resp.error.split("()")[0]
        : String(resp.error);

    if (
      error.toLowerCase().includes("quota")
    ) {
      setQuotaMessage(true);
    }

    setErrorMessage(error);
    setShowErrorMessage(true);

    return true;
  }

  return false;
};


const handleApplyFunctions = async () => {
  setLoading(true);

  if (!selectedFilePathRef.current.trim()) {
    setErrorMessage("Select the Data File to run the query");
    setShowErrorMessage(true);
    return;
  }

  await handleShowFunctions();

  const userName = userSessionRef.current["userName"]
    .trim()
    .replace(/^"+|"+$/g, "");

  const dataFile = selectedFilePathRef.current
    .split("/")
    .pop();

  const org_name =
    userSessionRef.current["orgName"] +
    "/users/" +
    userName +
    "/" +
    dataFile;

  const dbPath =
    `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}` +
    `data_mount/${org_name}/databases/_invertible_database`;

  const tableName = "_invertible_data_table";

  /*
   * Unique normal table used temporarily while creating
   * the grouped result.
   */
  const tempTableName =
    `_invertible_data_table_tmp_${Date.now()}`;

  let org =
    userSessionRef.current["orgName"];

  if (
    userSessionRef.current["orgName"] ===
    INVERTIBLE_MANAGED_ORG
  ) {
    org =
      userSessionRef.current["orgName"] +
      "`" +
      userSessionRef.current["userName"];
  }

  /*
   * ============================================================
   * Helper
   * ============================================================
   */

 

  const groupByColumns = [];
  const distinctColumns = [];
  const measures = [];

  for (
    const [col, transforms]
    of Object.entries(columnTransforms || {})
  ) {
    if (
      !Array.isArray(transforms) ||
      transforms.length === 0
    ) {
      continue;
    }

    const transform = transforms[0];

    if (!transform || !transform.fn) {
      continue;
    }

    let fn = transform.fn;

    /*
     * Normalize function name.
     */

    if (fn.includes("(")) {
      fn = fn.split("(")[0];
    }

    const normalizedFn =
      fn.trim().toLowerCase();

    /*
     * ==========================================================
     * GROUP BY
     * ==========================================================
     */

    if (
      normalizedFn === "group by" ||
      normalizedFn === "groupby"
    ) {
      groupByColumns.push(col);
      continue;
    }

    /*
     * ==========================================================
     * DISTINCT
     * ==========================================================
     */

    if (
      normalizedFn === "distinct"
    ) {
      distinctColumns.push(col);
      continue;
    }

    /*
     * ==========================================================
     * Everything else is a normal measure/function.
     * ==========================================================
     */

    measures.push({
      col,
      transform,
      fn,
    });
  }

  console.log(
    "Group By:",
    groupByColumns
  );

  console.log(
    "Distinct:",
    distinctColumns
  );

  console.log(
    "Measures:",
    measures
  );



  if (
    groupByColumns.length > 0 ||
    distinctColumns.length > 0
  ) {
    console.log(
      "handleApplyFunctions:: GROUP BY / DISTINCT mode"
    );

    const selectExpressions = [];

    for (
      const col of groupByColumns
    ) {
      selectExpressions.push(col);
    }



    for (
      const col of distinctColumns
    ) {
      selectExpressions.push(
        `COUNT(DISTINCT ${col}) AS ${col}`
      );
    }

    /*
     * ==========================================================
     * 3. Measures
     * ==========================================================
     */

    for (
      const {
        col,
        transform,
        fn,
      } of measures
    ) {
      let {
        newCol,
        applyMode,
        args = [],
      } = transform;

      const validArgs =
        Array.isArray(args)
          ? args.filter(
              (a) =>
                a &&
                a.value !== undefined &&
                a.value !== null &&
                a.value !== ""
            )
          : [];

      const finalArgs = [
        col,
        ...validArgs.map(
          (a) => a.value
        ),
      ];

      const argString =
        finalArgs.join(", ");

      const upperFn =
        fn.trim().toUpperCase();

      let functionExpression;

      /*
       * COUNT DISTINCT can also be selected as a normal
       * measure function.
       */

      if (
        upperFn === "COUNT DISTINCT" ||
        upperFn === "COUNT_DISTINCT" ||
        upperFn === "COUNT(DISTINCT"
      ) {
        functionExpression =
          `COUNT(DISTINCT ${col})`;
      } else {
        functionExpression =
          `${fn}(${argString})`;
      }

      /*
       * If user chose "new column", use that name.
       * Otherwise use the original column.
       */

      const alias =
        applyMode === "new" &&
        newCol
          ? newCol
          : col;

      selectExpressions.push(
        `${functionExpression} AS ${alias}`
      );
    }


    const hasMeasures =
      measures.length > 0;

    let selectSql;

    if (
      groupByColumns.length === 0 &&
      distinctColumns.length > 0 &&
      !hasMeasures
    ) {
      selectSql = `
        SELECT DISTINCT
          ${distinctColumns.join(",\n")}
        FROM ${tableName}
      `;
    } else {
      /*
       * ========================================================
       * GROUP BY query
       * ========================================================
       */

      if (
        selectExpressions.length === 0
      ) {
        setErrorMessage(
          "Please select at least one column or function."
        );

        setShowErrorMessage(true);

        return;
      }

      selectSql = `
        SELECT
          ${selectExpressions.join(",\n          ")}
        FROM ${tableName}
      `;

      if (
        groupByColumns.length > 0
      ) {
        selectSql += `
          GROUP BY
            ${groupByColumns.join(", ")}
        `;
      }
    }

    selectSql += ";";

    console.log(
      "Generated SQL:",
      selectSql
    );

  
    try {
    const tempTableName = `_invertible_data_table_new_${Date.now()}`;

    const createSql = `
      CREATE TABLE ${tempTableName} AS
      ${selectSql}
    `;

    let resp = await querySqlRustService(
      dbPath,
      createSql,
      userName,
      org
    );
    
    if (checkResponse(resp)) {
      return;
    }
    
    console.log("Temporary table created successfully:", tempTableName);
  

    if (checkResponse(resp)) {

      await querySqlRustService(
        dbPath,
        `DROP TABLE IF EXISTS ${tempTableName};`,
        userName,
        org
      );
    
      return;
    }

    const dropSql = `
      DROP TABLE ${tableName};
    `;
    
    resp = await querySqlRustService(
      dbPath,
      dropSql,
      userName,
      org
    );
    
    
    const renameSql = `
      ALTER TABLE ${tempTableName}
      RENAME TO ${tableName};
    `;
    resp = await querySqlRustService(
      dbPath,
      renameSql,
      userName,
      org
    );
    
    if (checkResponse(resp)) {
      return;
    }
    
    console.log(
      "Table successfully replaced:",
      tableName
    );
    

  /*
      const resp =
        await querySqlRustService(
          dbPath,
          transactionSql,
          userName,
          org
        );
  */

      if (
        checkResponse(resp)
      ) {
        return;
      }

      console.log(
        "Grouped result successfully applied."
      );

      setSuccessMessage(
        "Functions Successfully applied on data"
      );

      setShowSuccessMessage(true);

      handleExecuteRust(
        `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/${org_name}/databases/_invertible_database`,
        "select * from _invertible_data_table limit 1000",
        userName
      );

      return;

    } catch (e) {
      console.error(
        "GROUP BY transaction error:",
        e
      );

      try {
        await querySqlRustService(
          dbPath,
          "ROLLBACK;",
          userName,
          org
        );
      } catch (rollbackError) {
        console.error(
          "Rollback error:",
          rollbackError
        );
      }

      /*
       * Cleanup temporary table if necessary.
       */

      try {
        await querySqlRustService(
          dbPath,
          `
            DROP TABLE IF EXISTS
            ${tempTableName};
          `,
          userName,
          org
        );
      } catch (cleanupError) {
        console.error(
          "Temp table cleanup error:",
          cleanupError
        );
      }

      setErrorMessage(
        e?.message ||
          "Failed to apply functions"
      );

      setShowErrorMessage(true);

      return;
    }
  }

  /*
   * NORMAL FUNCTION MODE
   * No Group By / Distinct was selected.
   * This is essentially your original logic.
   */

  console.log(
    "handleApplyFunctions:: NORMAL mode"
  );

  for (
    const [col, transforms]
    of Object.entries(columnTransforms || {})
  ) {
    if (
      !Array.isArray(transforms) ||
      transforms.length === 0
    ) {
      continue;
    }

    let {
      fn,
      group,
      newCol,
      applyMode,
      args = [],
    } = transforms[0];

    if (!fn) {
      continue;
    }

    /*
     * Normalize function.
     */

    if (fn.includes("(")) {
      fn = fn.split("(")[0];
    }

    const validArgs =
      Array.isArray(args)
        ? args.filter(
            (a) =>
              a &&
              a.value !== undefined &&
              a.value !== null &&
              a.value !== ""
          )
        : [];

    const finalArgs = [
      col,
      ...validArgs.map(
        (a) => a.value
      ),
    ];

    const argString =
      finalArgs.join(", ");

    const createCols =
      getCreateCols(
        fn,
        group
      );

    const sqls = [];

    /*
     * Function creates columns
     */

    if (
      createCols &&
      Array.isArray(createCols) &&
      createCols.length > 0
    ) {
      for (
        const k of createCols
      ) {
        try {
          const resp =
            await querySqlRustService(
              dbPath,
              `
                ALTER TABLE ${tableName}
                ADD COLUMN ${k};
              `,
              userName,
              org
            );

          if (
            checkResponse(resp)
          ) {
            setLoading(false)
            return;
          }


        } catch (e) {
          console.log(
            "ALTER TABLE error:",
            e
          );

          setErrorMessage(
            e?.message ||
              `Failed to add column ${k}`
          );

          setShowErrorMessage(
            true
          );
          setLoading(false)
          return;
        }
      }
      const sleep = (ms) => new Promise(res => setTimeout(res, ms));
      await sleep(1000);

      const setClause =
        createCols
          .map(
            (k) =>
              `${k} = json_extract(res.val, '$.${k}')`
          )
          .join(",\n  ");

      sqls.push(`
        UPDATE ${tableName}
        SET
          ${setClause}
        FROM (
          SELECT
            rowid,
            ${fn}(${argString}) AS val
          FROM ${tableName}
        ) AS res
        WHERE ${tableName}.rowid = res.rowid;
      `);
    }

    /*
     * Normal function
     */

    else {
      /*
       * New column.
       */

      if (
        applyMode === "new" &&
        newCol
      ) {
        try {
          const resp =
            await querySqlRustService(
              dbPath,
              `
                ALTER TABLE ${tableName}
                ADD COLUMN ${newCol};
              `,
              userName,
              org
            );

          if (
            checkResponse(resp)
          ) {
            setLoading(false)
            return;
          }

        } catch (e) {
          console.error(
            "ALTER TABLE error:",
            e
          );

          setErrorMessage(
            e?.message ||
              `Failed to add column ${newCol}`
          );

          setShowErrorMessage(
            true
          );

          return;
        }

        sqls.push(`
          UPDATE ${tableName}
          SET ${newCol} =
            ${fn}(${argString});
        `);
      }

      /*
       * Existing column.
       */

      else {
        sqls.push(`
          UPDATE ${tableName}
          SET ${col} =
            ${fn}(${argString});
        `);
      }
    }

    /*
     * Execute normal SQL
     */

    for (
      const sql of sqls
    ) {
      console.log(
        "Executing SQL:",
        sql
      );

      try {
        const resp =
          await querySqlRustService(
            dbPath,
            sql,
            userName,
            org
          );

        if (
          checkResponse(resp)
        ) {
          return;
        }

      } catch (e) {
        console.error(
          "Function execution error:",
          e
        );

        setErrorMessage(
          e?.message ||
            "Failed to apply function"
        );

        setShowErrorMessage(
          true
        );

        return;
      }
    }
  }

  /*
   * Success
   */

  setSuccessMessage(
    "Functions Successfully applied on data"
  );

  setShowSuccessMessage(
    true
  );


  handleExecuteRust(
    `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/${org_name}/databases/_invertible_database`,
    "select * from _invertible_data_table limit 1000",
    userName
  );
  setLoading(false);
};



const handleLoadData= async (event,dataFileName) => {

    try {
      if (!selectedFilePathRef.current.trim()) {
        setErrorMessage("Select the Data File to run the query");
        setShowErrorMessage(true);
        return;
      }

      const userName = userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '')
      setLoading(true);
      const dataFile = selectedFilePathRef.current.split('/').pop();
      const event = {
        "database": "_invertible_database",
        "dir_path": "_invertible_data",
        "file_type": loadFileType,
        "staging_table": "_invertible_data_table",
        "success_dir": "_invertible_data_success",
        "failure_dir": "_invertible_data_failure",
      }
      const configFile = userName + "/" + dataFile + "/config/" + featureRef.current + "/config_file"
      const updatedData = await updateConnection(JSON.stringify(event), configFile,userSessionRef.current["orgName"],"default","reports");
      //Copy data file
      console.log("dataFile::1",dataFile);
      const org_name = userSessionRef.current["orgName"] +  "/users/" + userName+ "/" + dataFile
      console.log("dataFile::12",org_name);
      const cpDataFile = await copyFile(selectedFilePathRef.current,`${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org_name + "/_invertible_data" + "/",userSessionRef.current["orgName"])
      const cpFuntionsFile = await copyFile("/home/stateFiles/" + org_name + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/functions/functions" , `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DATA_DIR}functions/functions`,userSessionRef.current["orgName"])
      console.log("cpFuntionsFile::1",cpFuntionsFile)
      const current_time = new Date();


      let org = userSessionRef.current["orgName"];
      if (userSessionRef.current["orgName"]==INVERTIBLE_MANAGED_ORG){
          org = userSessionRef.current["orgName"] + "`" + userSessionRef.current["userName"];
      }
      const resp = await querySqlRustService(`${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org_name + "/databases/_invertible_database","Drop Table If Exists _invertible_data_table",userName,org)
      const testResponse = await loadFile(event, configFile, selectedFilePathRef.current,userName,featureRef.current,userSessionRef.current["orgName"],userName,org);
      const sleep = (ms) => new Promise(res => setTimeout(res, ms)); 
      await sleep(2000);
      const logText = await getLog(0,"/home/invertible_databases/" + userSessionRef.current["orgName"] + "/public.db",`${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DATA_DIR}` + org_name + "/_invertible_data" + "/" + dataFile,userSessionRef.current["orgName"]);
      const rawArray = JSON.parse(logText);
      const parsedLogLines = rawArray.slice() // copy so original is not mutated
      .sort((a, b) => b - a)
      .slice(0, 10)
      .map((entry) => {
        try {
          const parsed = JSON.parse(entry);
          let color = '';

          // keep only ERROR logs
          if (parsed.log_level !== "ERROR") {
            return null
          } else if (parsed.log_level === 'ERROR' && `${parsed.log_time}` > `${current_time}`) {
            color = 'red';
          }

          return `${parsed.log_time} ERROR ${parsed.message.replace(`${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DATA_DIR}`,"")}`;
        } catch {
          return null;
        }
      })
      .filter(Boolean);
      //setLogContent(parsedLogLines.join('\n'));
      //setOffset(offset);
      if (parsedLogLines.join('\n').length >0) {
      setErrorMessage(parsedLogLines.join('\n'));
      setShowErrorMessage(true);
      } else {
        //setSuccessMessage("File Loaded Successfully");
        //setShowSuccessMessage(true);   
        const sleep = (ms) => new Promise(res => setTimeout(res, ms));     
        for (let i = 0; i < 3; i++) {
          const queryResp = await handleExecuteRust(`${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org_name + "/databases/_invertible_database","select * from _invertible_data_table limit 1000");
          if (resultRowsRef.current.length > 0){
            break;
          }
          console.log("loadData::",i)
          await sleep(2000);
        }
        setSuccessMessage("File Loaded Successfully");
        setShowSuccessMessage(true);   
      }
      
    } catch (error) {
      if (error.message.includes("quota")) {
        setQuotaMessage(true);  
      }
      setErrorMessage(error.message);
      setShowErrorMessage(true);  
      console.error('Load Error:', error.message);
    } finally {
      setLoading(false)
    }
  };

const handleExecuteWriteFile = async () => {
  console.log("Write file clicked::11");
  
    if (!fileNameRef.current || fileNameRef.current.trim() === "") {
        setErrorMessage("File Name cannot be empty.");
        setShowErrorMessage(true);
        return;
      }
    
    setLoading(true);
    console.log("Write file clicked::113");
    try {
      const userName = userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '')
      const dataFile = selectedFilePathRef.current.split('/').pop();
      const org = userSessionRef.current["orgName"];
      const org_name = org + "/users/" + userName+ "/" + dataFile
      console.log("write_columns::1",selectedColumns)
      
      let query;
      if (selectedColumns.length == 0){
          query = "select * from _invertible_data_table";
      } else {
          query = `select ${selectedColumns.join(",")} from _invertible_data_table`;
      }
      
      console.log("write_columns::11",query)
      let org2 = userSessionRef.current["orgName"];
      if (userSessionRef.current["orgName"]==INVERTIBLE_MANAGED_ORG){
          //org2 = userSessionRef.current["orgName"] + "`" + userSessionRef.current["userName"];
          org2 = userSessionRef.current["orgName"] + "/users/" + userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '');
         //home/rust/data_mount/invertible_managed`"vasistabhargava@gmail.com"/output/data/testFile1
      }  


      const data = await wrietSqlResultToFile(`${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org_name + "/databases/_invertible_database",query, fileName, fileType,org2);
      const text = await data.text();
      if (!data.ok) {
        //setError(text);
        setErrorMessage(text);
        setShowErrorMessage(true);
      } else {
        setSuccessMessage(`Result written successfully to file '${fileName}'`);
        setShowSuccessMessage(true);
      }
      
        
      console.log('Running SQL::12', data);
    } catch (err) {
      setResultCols([]);
      setResultRows([]);
    } finally {
      setLoading(false);
    }
  };


const getUploadedFiles = async () => {
    try {
      let  path =  "/home/stateFiles/" + userSessionRef.current["orgName"] + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/uploads"
      
      if (userSessionRef.current["orgName"]==INVERTIBLE_MANAGED_ORG){
        //org2 = userSessionRef.current["orgName"] + "`" + userSessionRef.current["userName"];
         //const org = userSessionRef.current["orgName"] + "/users/" + userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '');
         path = `/home/stateFiles/${userSessionRef.current["orgName"]}/${process.env.REACT_APP_ARCHITECTURE_NAME}/uploads/` + userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '') +  "/uploads";
     }  
      
      const filesList = await listOfFileNamesPageDir(path);
  
      setDataFiles(filesList);
      setFirstFolderName(filesList.info.name || '');
      console.log("fetching files::1", JSON.stringify(filesList));
    } catch (error) {
      console.error('Error fetching uploads:', error);
    }
  };

  const debouncedSave = useRef(
    debounce(async (val) => {
      try {
        const authHeader = await getAuthHeader(); // ✅ resolve first
  
        await fetch(
          `${process.env.REACT_APP_SQL_GENERATOR}/createStateFile`,
          {
            method: "POST",
            headers: {
              "Content-Type": "text/plain",
              Authorization: authHeader?.Authorization, // ✅ token here
            },
            body: JSON.stringify({
              org_name: userSessionRef.current["orgName"],
              architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
              state_type: `${process.env.REACT_APP_STATE_TYPE_REPORTS}`,
              connection_name: `${
                userSessionRef.current["userName"]
                  .trim()
                  .replace(/^"+|"+$/g, "")
              }/appliedFunctions/${selectedFilePathRef.current
                .split("/")
                .pop()}`,
              file_name: "Appliedfunctions",
              file_content: JSON.stringify(val),
            }),
          }
        );
      } catch (err) {
        console.error(err);
      }
    }, 1000)
  ).current;

const handleSaveState = (val) => {
    console.log("debounceing save::1",val)
    debouncedSave(val);
  };

const handleGetState = async () => {
    const reportData = await readEachReportData(
        `${userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '')}/appliedFunctions/${selectedFilePathRef.current.split('/').pop()}`,
        "Appliedfunctions",
        userSessionRef.current["orgName"]
    );
    console.log("columnTransformsRef:11", reportData);
    setColumnTransforms(reportData)
    console.log("columnTransformsRef:112", columnTransformsRef.current);

};

const getLatestFunctionForColumn = (col) => {
    const transforms = columnTransformsRef.current?.[col];
    if (!Array.isArray(transforms) || transforms.length === 0) {
      return { fn: "", group:"" ,newCol: "" , applyMode: "",args:[]};
    }
    console.log("columnTransforms::111", transforms);
    const trans = transforms[transforms.length - 1]; // latest
    return {
      fn: trans.fn || "",
      group: trans.group || "",
      newCol: trans.newCol || "",
      applyMode: trans.applyMode || "",
      args: {[col]:trans.args || []},
    };
  };
  
  const { fn: selectedFunctionVal, group: selectedFunctionGroupVal ,newCol: selectedNewColVal,applyMode: selectedNewColBool,args: selectedArgsVal} =
    getLatestFunctionForColumn(activeColumnRef.current);

    console.log(
      "columnTransforms::11112",
      activeColumnRef.current,
      selectedFunctionVal,
      selectedNewColVal,
      selectedNewColBool,
      selectedArgsVal,
      selectedFunctionGroupVal
    );

  const latest= getLatestFunctionForColumn(activeColumnRef.current);

    useEffect(() => {
      if (!userSessionRef) return;
      if (!latest) {
        setApplyMode("existing");
        setNewColumnName("");
        return;
      }
    
      if (latest.applyMode === "new" && latest.newCol) {
        setApplyMode("new");
        setNewColumnName(latest.newCol);   // ✅ restore name
      } else {
        setApplyMode("existing");
        setNewColumnName("");
      }
    }, [activeColumnRef.current,userSessionRef]);

    useEffect(() => {
      if (!userSessionRef) return;
      if (!functionPanelOpen || !selectedColumnRef.current) return;
    
      const t = getLatestFunctionForColumn(selectedColumnRef.current);
    
      if (!t) {
        // reset if no function yet
        setSelectedFunction("");
        setSelectedFunctionGroup("");
        setApplyMode("existing");
        setNewColumnName("");
        return;
      }
    
      setSelectedFunction(t.fn || "");
      setSelectedFunctionGroup(t.group || "");
      setApplyMode(t.applyMode || "existing");
      setNewColumnName(t.newCol || "");
    }, [selectedColumn, functionPanelOpen,userSessionRef]);


const getScore = (text, search) => {
      text = text.toLowerCase();
      search = search.toLowerCase().trim();
    
      if (!search) return 1;
    
      // exact match
      if (text === search) return 100;
    
      // starts with
      if (text.startsWith(search)) return 80;
    
      // word starts
      if (text.split(/[\s(,]+/).some(w => w.startsWith(search))) return 60;
    
      // includes
      if (text.includes(search)) return 40;
    
      // fuzzy (loose fallback)
      let i = 0;
      for (let j = 0; j < text.length && i < search.length; j++) {
        if (text[j] === search[i]) i++;
      }
      if (i === search.length) return 20;
    
      return 0;
};
    
/*
const filterFuncs = (list, search = "") => {
  return list
    .map(f => ({
      ...f,
      score: getScore(f.signature, search)
    }))
    .filter(f => f.score > 0)
    .sort((a, b) => b.score - a.score);
};
*/

const filterFuncs = (list, search = "") => {
  if (!Array.isArray(list) || list.length === 0) {
    return [];
  }

  return list
    .map(f => ({
      ...f,
      score: getScore(f.signature || "", search)
    }))
    .filter(f => f.score > 0)
    .sort((a, b) => b.score - a.score);
};



const handleShowFunctions = async () => {
    console.log("updating fucntionslist")
      try {
        const udfFuncs= await readEachConnection("functions", "functions", userSessionRef.current["orgName"]);
        setFuncUDFContent(udfFuncs);
        const standardFuncs= await readFiles("boolean", "documents","functions","functions","/home/invertibleFiles/");
        setFuncStandardContent(standardFuncs);
        const carbonFuncs= await readFiles("boolean", "documents","functions","carbon_emission_calculations","/home/invertibleFiles/");
        setFuncCarbonContent(carbonFuncs);
        console.log("createCols::13",carbonFuncs)
        const sqliteFuncs= await readFiles("boolean", "documents","functions","sqlite_functions","/home/invertibleFiles/");
        setFuncSqliteContent(sqliteFuncs);
        const groupFuncs= await readFiles("boolean", "documents","functions","group_functions","/home/invertibleFiles/");
        setGroupContent(groupFuncs);
      } catch (err) {
        console.error("Failed to fetch functions:", err);
      }
};

  
  useEffect(() => {
    if (!userSessionRef) return;
    if (functionPanelOpen) {
      handleShowFunctions();
    }
  }, [functionPanelOpen,userSessionRef]);
  
  const onClickHandler = () => {
    handleLoadData();
    handleGetState();
  };

  const onClickRefreshHandler = () => {
    if (!selectedFilePathRef.current.trim()) {
      setErrorMessage("Select the Data File to run the query");
      setShowErrorMessage(true);
      return;
    }
    handleRefreshData("select * from _invertible_data_table limit 1000");
    handleGetState();
  };
  const hasArgs = (argsByColumn[selectedColumn] || []).length > 0;
  console.log("hasArgs::1",hasArgs,argsByColumn[selectedColumn],argsByColumnRef.current)
  const isArgsOpen =
  extraArgsOpenFor === selectedColumn || hasArgs;
  console.log("hasArgs::11",isArgsOpen)

  const handleAgentAi = async () => {
    if (!apiKey || apiKey.trim() === "") {
      setErrorMessage("API Key cannot be empty.")
      setShowErrorMessage(true)
      return;
    }
    setLoading(true);
    const queryDesc =  queryDescription + " " + "for table _invertible_data_table";
    const resp = await generateSqlWithAgentAi(queryDesc,model,apiKey,userSessionRef.current["orgName"]) 

    //console.log("AgentAiresp::101",resp)
    if (resp==undefined || resp.includes("Error")){
      setErrorMessage(resp);
      setShowErrorMessage(true)
      setSqlDrawerOpen(false)
    } else {
      const inner = JSON.parse(resp);
      //console.log("generateSqlWithAgentAi::12",resp)
      //setValue((prev) => prev + "\n" + inner.query);
      setGeneratedSql(inner.query);
      //debouncedSave(valueRef.current);
    }

    setLoading(false)
  };

  const handleApplySql = async () => {
    setLoading(true);
    if (!generatedSql.trim()) {
      setSqlDrawerOpen(false);
      return;
    }
  
    if (!selectedFilePathRef.current.trim()) {
      setErrorMessage("Select the Data File to run the query");
      setShowErrorMessage(true);
      setSqlDrawerOpen(false);
      return;
    }
  
    const userName = userSessionRef.current.userName
      .trim()
      .replace(/^"+|"+$/g, "");
  
    const dataFile = selectedFilePathRef.current.split("/").pop();
  
    const org =
      `${userSessionRef.current.orgName}/users/${userName}/${dataFile}`;
  
    const dbPath =
      `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}` +
      `data_mount/${org}/databases/_invertible_database`;
  
    const tableName = "_invertible_data_table";
    const tempTableName = `_invertible_data_table_new_${Date.now()}`;
  
    // Remove trailing semicolon
    const selectSql = generatedSql.trim().replace(/;+\s*$/, "");
  
    try {
  
      //
      // 1. Create temporary table from user's SQL
      //
      const createSql = `
        CREATE TABLE ${tempTableName} AS
        ${selectSql}
      `;
  
      let resp = await querySqlRustService(
        dbPath,
        createSql,
        userName,
        org
      );

      if (resp?.error) {
        const errorMessage =
          typeof resp.error === "string"
            ? resp.error.replace(/^Query failed:\s*/i, "")
            : String(resp.error);
      
        setErrorMessage(errorMessage);
        setShowErrorMessage(true);
        setSqlDrawerOpen(false);
        return;
      }
  
      if (checkResponse(resp)) {
        await querySqlRustService(
          dbPath,
          `DROP TABLE IF EXISTS ${tempTableName};`,
          userName,
          org
        );
        return;
      }
  
      console.log(
        "Temporary table created successfully:",
        tempTableName
      );
  
      //
      // 2. Drop original table
      //
      const dropSql = `
        DROP TABLE IF EXISTS ${tableName};
      `;
  
      resp = await querySqlRustService(
        dbPath,
        dropSql,
        userName,
        org
      );

  
      if (checkResponse(resp)) {
        await querySqlRustService(
          dbPath,
          `DROP TABLE IF EXISTS ${tempTableName};`,
          userName,
          org
        );
        return;
      }
  
      //
      // 3. Rename temp table
      //
      const renameSql = `
        ALTER TABLE ${tempTableName}
        RENAME TO ${tableName};
      `;
  
      resp = await querySqlRustService(
        dbPath,
        renameSql,
        userName,
        org
      );
  
      if (checkResponse(resp)) {
        return;
      }
  
      console.log(
        "Table successfully replaced:",
        tableName
      );
  
      setSuccessMessage("SQL successfully applied on data");
      setShowSuccessMessage(true);
      setSqlDrawerOpen(false);
  
      //
      // 4. Reload table into UI
      //
      await handleExecuteRust(
        dbPath,
        `SELECT * FROM ${tableName} LIMIT 1000`,
        userName
      );
  
    } catch (error) {
      console.error("Apply SQL error:", error);
  
      setErrorMessage(
        error?.message || "Failed to apply SQL"
      );
      setShowErrorMessage(true);
  
    } finally {
      setLoading(false);
    }
  };

return (
    <div className="main-container">
    {showSuccessMessage && (
    <div
    className="success-message"
    id="success-banner"
    style={{
      position: "relative",
      backgroundColor: "#dcfce7",
      color: "#166534",
      padding: "12px 40px 12px 12px",
      borderRadius: "6px",
      marginBottom: "12px",
      fontWeight: 500,
      fontSize: "14px",
    }}
  >
    <span>✅ {successMessage}</span>
    <button
      onClick={() => setShowSuccessMessage(false)}
      style={{
        position: "absolute",
        top: "8px",          // moves it to the top
        right: "10px",       // aligns it to the right edge
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#b91c1c",
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "0", 
      }}
    >
      ×
    </button>
  </div>
)}

{showErrorMessage && (
  <div
    className="error-message"
    id="error-banner"
    style={{
      position: "relative",
      backgroundColor: "#fee2e2",
      color: "#b91c1c",
      padding: "12px 40px 12px 12px",
      borderRadius: "6px",
      marginBottom: "12px",
      fontWeight: 500,
      fontSize: "14px",
    }}
  >
    <div style={{ whiteSpace: "pre-line", color: "red" }}>
      {quotaMessage ? (
        <>
          <strong>USAGE LIMIT REACHED</strong>:
          {errorMessage}
        </>
      ) : (
        <>
          <strong>ERROR OCCURRED</strong>: Check your file options or function selections.
          Ensure the file format and the type of information you entered (numbers vs. text)
          matches the field requirements.
          <br />
          <br></br>
          <strong>Message:</strong>: {errorMessage}
        </>
      )}
    </div>
    <button
      onClick={() => setShowErrorMessage(false)}
      style={{
        position: "absolute",
        top: "8px",          // moves it to the top
        right: "10px",       // aligns it to the right edge
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#b91c1c",
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "0", 
      }}
    >
      ×
    </button>
  </div>
)}

<Box
  sx={{
    display: "flex",
    justifyContent: "center",
    width: "100%",
    my: 2,
  }}
>
<Button
  variant="outlined"
  size="small"
  onClick={() => setSqlDrawerOpen(true)}
  sx={{
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "none",
    borderRadius: "6px",
    borderColor: "#16a34a",
    color: "#16a34a",
    px: 2.5,
    py: 0.75,
    borderWidth: 2,
    transition: "all 0.2s ease",
    "&:hover": {
        backgroundColor: "#16a34a",
        color: "#fff",
      },
  }}
>
  Generate SQL with AI
</Button>
</Box>


  {/* SQL Drawer */}
<Drawer
  anchor="top"
  open={sqlDrawerOpen}
  onClose={() => setSqlDrawerOpen(false)}
  PaperProps={{
    sx: {
      maxHeight: "80vh",
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px",
    },
  }}
>
  <div
    style={{
      padding: "18px 24px 22px 24px",
    }}
  >
    {/* Header */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          fontSize: "16px",
          fontWeight: 600,
        }}
      >
        Generate SQL
      </div>

      <IconButton
        size="small"
        onClick={() => setSqlDrawerOpen(false)}
      >
        <Close />
      </IconButton>
    </div>

    {/* Model + API Key */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        fontSize: "13px",
      }}
    >
      {/* Model */}
      <FormControl
        size="small"
        sx={{
          width: "260px",
        }}
      >
        <InputLabel>LLM Model</InputLabel>

        <Select
          value={model}
          onChange={(e) =>
            setModel(e.target.value)
          }
          label="LLM Model"
          sx={{
            borderRadius: "8px",
            fontSize: "13px",

            "& .MuiSelect-select": {
              paddingY: "7px",
            },
          }}
        >
          <MenuItem value="claude-haiku-4-5-20251001">
            claude-haiku-4-5-20251001
          </MenuItem>

          <MenuItem value="gpt-4o-mini">
            gpt-4o-mini (OpenAI)
          </MenuItem>
        </Select>
      </FormControl>

      {/* API Key */}
      <TextField
        placeholder="API Key"
        size="small"
        type={
          showKey
            ? "text"
            : "password"
        }
        value={apiKey}
        onChange={(e) =>
          setApiKey(e.target.value)
        }
        sx={{
          width: "260px",

          "& .MuiInputBase-root": {
            borderRadius: "8px",
            fontSize: "13px",
          },

          "& input::placeholder": {
            fontSize: "12px",
            opacity: 0.7,
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() =>
                  setShowKey(!showKey)
                }
                edge="end"
                size="small"
                aria-label="toggle API key visibility"
              >
                {showKey ? (
                  <VisibilityOff />
                ) : (
                  <Visibility />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </div>

    {/* Query Description + Generate */}
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginTop: "14px",
        alignItems: "flex-start",
      }}
    >
      <TextField
        size="small"
        fullWidth
        placeholder="Describe the SQL query you want to generate..."
        value={queryDescription}
        onChange={(e) => {
          setQueryDescription(
            e.target.value
          );

          localStorage.setItem(
            "queryDesc",
            e.target.value
          );
        }}
        multiline
        minRows={2}
        maxRows={5}
        sx={{
          "& .MuiInputBase-root": {
            fontSize: "13px",
            borderRadius: "8px",
          },
        }}
      />

      <button
        onClick={async () => {
          const result =
            await handleAgentAi();

          /*
           * If handleAgentAi returns the
           * generated SQL, show it here.
           */
          //if (result) {
            //setGeneratedSql(result);
          //}
        }}
        disabled={loading}
        style={{
          height: "38px",
          backgroundColor: "#9333ea",
          color: "white",
          padding: "6px 14px",
          borderRadius: "6px",
          border: "none",
          fontSize: "13px",
          cursor: loading
            ? "default"
            : "pointer",
          fontWeight: 500,
          whiteSpace: "nowrap",
          opacity: loading ? 0.6 : 1,
        }}
      >
        {loading
          ? "Generating..."
          : "Generate SQL"}
      </button>
    </div>

    {/* Generated SQL */}
  {/* SQL Editor */}
<div style={{ marginTop: "18px" }}>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "6px",
    }}
  >
    <div
      style={{
        fontSize: "13px",
        fontWeight: 600,
      }}
    >
      SQL Query
    </div>

    <Button
      variant="contained"
      size="small"
      onClick={handleApplySql}
      disabled={!generatedSql.trim() || loading}
      sx={{
        fontSize: "12px",
        textTransform: "none",
        borderRadius: "6px",
      }}
    >
      Apply SQL
    </Button>
  </div>

  <TextField
  fullWidth
  multiline
  minRows={10}
  maxRows={20}
  value={generatedSql}
  onChange={(e) => {
    setGeneratedSql(e.target.value);
    setUseSql(true);
  }}
  placeholder="Generated SQL will appear here..."
  variant="outlined"
  sx={{
    "& .MuiInputBase-root": {
      fontFamily:
        '"SFMono-Regular", Consolas, "Liberation Mono", monospace',
      fontSize: "12px",
      lineHeight: 1.5,
      alignItems: "flex-start",
      backgroundColor: "#f8fafc",
      borderRadius: "8px",

      /*
       * Allow scrolling inside the SQL editor
       */
      overflow: "auto",
    },

    "& textarea": {
      padding: "12px",

      /*
       * Don't wrap long SQL lines.
       * Horizontal scrolling will be used instead.
       */
      whiteSpace: "pre",

      overflow: "auto",
    },
  }}
/>


</div>
  </div>
</Drawer>



<div style={{ backgroundColor: "#f8fafc", minHeight: "100vh", fontFamily: "Inter, sans-serif" }}>
      <AlertBanner message={apiErrorRef.current} onClose={() => setApiError("")} />
  
      {loading && (
        <div className="overlay">
          <div className="loading-container">
            <Spinner />
            <p className="please-wait">Please wait...</p>
          </div>
        </div>
      )}
  
      <div
        className="page-container"
        style={{
          display: "flex",
          gap: "16px",
          padding: "16px 24px",
          height: "calc(100vh - 80px)",
        }}
      >

   {/* LEFT PANEL */}
<div
  className="popup-datatable-container"
  style={{
    width: "340px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    gap: "12px",
    overflowY: "auto",
  }}
>
  {/* DATA FILES */}
  <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
    <label htmlFor="dataFilesDropdown" style={{ fontSize: "13px" }}>
      Data Files
    </label>
    <select
      id="dataFilesDropdown"
      value={selectedFilePath}
      onChange={(e) => setSelectedFilePath(e.target.value)}
      style={{
        width: "100%",
        padding: "8px",
        fontSize: "13px",
        borderRadius: "6px",
        border: "1px solid #d1d5db",
      }}
    >
      <option value="">Select a file...</option>
      {dataFiles?.children?.map((file, index) => (
        <option key={index} value={file.path}>
          {file.info?.name || file.path}
        </option>
      ))}
    </select>
  </div>

  {/* LOAD FILE TYPE */}
  <FormControl size="small" sx={{ width: "100%" }}>
    <InputLabel>File Type</InputLabel>
    <Select
      value={loadFileType}
      onChange={(e) => setLoadFileType(e.target.value)}
      label="File Type"
      sx={{
        borderRadius: "6px",
        fontSize: "13px",
        "& .MuiSelect-select": { paddingY: "6px" },
      }}
    >
      <MenuItem value="csv">CSV</MenuItem>
      <MenuItem value="excel">Excel</MenuItem>
    </Select>
  </FormControl>

  {/* LOAD BUTTON */}
  <div>
    <Button
    onClick={onClickHandler}
    disabled={loading}
    variant="outlined"
    size="small"
    sx={{
      width: "100%",
      borderRadius: "6px",
      borderColor: "#16a34a",
      color: "#16a34a",
      fontWeight: 500,
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#16a34a",
        color: "#fff",
      },
    }}
  >
    Load From File
  </Button>
  </div>

  <hr style={{ border: "none", borderTop: "1px solid #e5e7eb" }} />

  {/* FILE NAME */}
  <input
    type="text"
    placeholder="File Name"
    value={fileName}
    onChange={(e) => setFileName(e.target.value)}
    style={{
      width: "95%",
      padding: "8px",
      borderRadius: "6px",
      border: "1px solid #d1d5db",
      fontSize: "13px",
    }}
  />

  {/* SAVE FILE TYPE */}
  <FormControl size="small" sx={{ width: "100%" }}>
    <InputLabel>File Type</InputLabel>
    <Select
      value={fileType}
      onChange={(e) => setFileType(e.target.value)}
      label="File Type"
      sx={{
        borderRadius: "6px",
        fontSize: "13px",
        "& .MuiSelect-select": { paddingY: "6px" },
      }}
    >
      <MenuItem value="csv">CSV</MenuItem>
      <MenuItem value="parquet">Parquet</MenuItem>
    </Select>
  </FormControl>

  {/* WRITE BUTTON */}
  <Button
    onClick={handleExecuteWriteFile}
    variant="outlined"
    size="small"
    sx={{
      width: "100%",
      borderRadius: "6px",
      borderColor: "#16a34a",
      color: "#16a34a",
      fontWeight: 500,
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#16a34a",
        color: "#fff",
      },
    }}
  >
    Write Result To File
  </Button>
</div>

  
{/* RIGHT PANEL */}
<div
  style={{
    flex: 1,
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    height: "100%",        // ensures vertical fill
    overflow: "hidden",    // prevent double scrollbars
  }}
>

  {/* BUTTONS */}

  {/* Model Selection */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "16px",              // consistent horizontal space
    marginTop: "16px",
    fontSize: "13px",
  }}
>

  {/* API Key Input */}
</div>


{/* FUNCTION PANEL BUTTON */}
<div style={{ display: "flex", alignItems: "center", gap: "8px",marginBottom: '1.25em'}}>
<button
  onClick={() => {
    setSelectedFunction(selectedFunctionVal)
    setSelectedFunctionGroup(selectedFunctionGroupVal)
    setSelectedNewColumn(selectedNewColVal)
    setFunctionPanelOpen(true);
    //setExtraArgs(selectedArgsVal);
    setArgsByColumn(selectedArgsVal);
    //setFuncColsCreateContent
  }}
    style={{
      backgroundColor: "#2563eb",
      border: "none",
      color: "white",
      padding: "6px 10px",
      borderRadius: "6px",
      fontSize: "13px",
      width: "fit-content",
      whiteSpace: "nowrap",
    }}
>
  Add Function
</button>

{/* APPLY FUNCTIONS BUTTON */}
<button
  onClick={() => {
    setShowApplyPreview(true);
  }}
    style={{
      backgroundColor: "#2563eb",
      border: "none",
      color: "white",
      padding: "6px 10px",
      borderRadius: "6px",
      fontSize: "13px",
      width: "fit-content", // 👈 key line
      whiteSpace: "nowrap",
    }}
>
  Apply Functions on Data
</button>

{showApplyPreviewRef.current && (
  <ApplyFunctionsDialog
    open={showApplyPreview}
    onCancel={() => setShowApplyPreview(false)}
    onConfirm={() => {
      handleApplyFunctions();
      setShowApplyPreview(false);
    }}
    columnTransforms={columnTransforms ?? {}}
  />
)}


{/* REFRESH BUTTON */}
<button
  onClick={onClickRefreshHandler}
    style={{
      backgroundColor: "#2563eb",
      border: "none",
      color: "white",
      padding: "6px 10px",
      borderRadius: "6px",
      fontSize: "13px",
      width: "fit-content", // 👈 key line
      whiteSpace: "nowrap",
    }}
>
  Load From Table
</button>
<div style={{ display: "flex", alignItems: "right"}}>
<InfoTip
        keyword="apply_functions"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
  </div>
  </div>



{functionPanelOpen && (
  <div
    className="function-popup"
    style={{
      background: "#fff",
      padding: "16px",
      borderRadius: "10px",
      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
      width: "400px",
      fontFamily: "system-ui, sans-serif",
    }}
  >
    <p style={{ margin: "0 0 12px 0", color: "#374151" }}>
      <b>Column:</b> {selectedColumn}
    </p>

    {/* FUNCTION INPUT */}
    <div style={{ position: "relative", width: "100%" }}>
      <input
        type="text"
        placeholder="Select Function"
        value={selectedFunctionRef.current}
        onChange={(e) => setSelectedFunction(e.target.value)}
        onFocus={() => setIsFuncOpen(true)}
        style={{
          width: "95%",
          padding: "8px 10px",
          border: "1px solid #d1d5db",
          borderRadius: "6px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        }}
      />

      {/* DROPDOWN PANEL */}
      {isFuncOpen && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            width: "95%",
            zIndex: 20,
            maxHeight: "220px",
            overflowY: "auto",
            border: "1px solid #d1d5db",
            borderRadius: "6px",
            background: "#fff",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            padding: "6px",
          }}
        >
          {/* SEARCH */}
          <input
            type="text"
            placeholder="Search functions..."
            value={funcSearchRef.current}
            onChange={(e) => setFuncSearch(e.target.value)}
            style={{
              width: "90%",
              padding: "6px 8px",
              marginBottom: "6px",
              border: "1px solid #d1d5db",
              borderRadius: "4px",
            }}
          />

          {/* DEFAULT SELECT */}
          {!funcSearchRef.current && (
            <div
              onClick={() => {
                setSelectedFunction("");
                setIsFuncOpen(false);
              }}
              style={{
                padding: "6px",
                fontStyle: "italic",
                color: "#9ca3af",
                cursor: "pointer",
              }}
            >
              -- None--
            </div>
          )}

          {/* UDF FUNCTIONS */}
          <div style={{ marginTop: "8px" }}>
            <div
              style={{ fontWeight: 600, cursor: "pointer", marginBottom: "4px" }}
              onClick={() => (setOpenGroup(openGroup === "udf" ? null : "udf"))}
            >
              UDFs {openGroup === "udf" ? "▾" : "▸"}
            </div>
            {openGroup === "udf" && userSessionRef.current["orgName"]!==INVERTIBLE_MANAGED_ORG &&
              filterFuncs(funcUDFContent, funcSearchRef.current).map((fn) => (
                <div
                  key={fn.name}
                  onClick={() => {
                    setSelectedFunction(fn.name);
                    setSelectedFunctionGroup(openGroup);
                    setIsFuncOpen(false);
                  }}
                  style={{
                    padding: "6px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    background:
                      selectedFunction === fn.name ? "#e0f2fe" : "transparent",
                  }}
                >
                  {fn.name}
                </div>
              ))}
          </div>

          {/* STANDARD FUNCTIONS */}
          <div>
            <div
              style={{ fontWeight: 600, cursor: "pointer", marginBottom: "4px" }}
              onClick={() =>
                setOpenGroup(openGroup === "standard" ? null : "standard")
              }
            >
              Invertible Functions {openGroup === "standard" ? "▾" : "▸"}
            </div>
            {openGroup === "standard" &&
              filterFuncs(funcStandardContent, funcSearchRef.current).map((fn) => (
                <div
                  key={fn.name}
                  onClick={() => {
                    setSelectedFunction(fn.name);
                    setSelectedFunctionGroup(openGroup);
                    setIsFuncOpen(false);
                  }}
                  style={{
                    padding: "6px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    background:
                      selectedFunction === fn.name ? "#e0f2fe" : "transparent",
                  }}
                >
                  {fn.name}
                </div>
              ))}
          </div>

          {/* GROUP FUNCTIONS */}
          <div>
            <div
              style={{ fontWeight: 600, cursor: "pointer", marginBottom: "4px" }}
              onClick={() =>
                setOpenGroup(openGroup === "group" ? null : "group")
              }
            >
              Group Operations {openGroup === "group" ? "▾" : "▸"}
            </div>
            {openGroup === "group" &&
              filterFuncs(funcGroupContent, funcSearchRef.current).map((fn) => (
                <div
                  key={fn.name}
                  onClick={() => {
                    setSelectedFunction(fn.name);
                    setSelectedFunctionGroup(openGroup);
                    setIsFuncOpen(false);
                  }}
                  style={{
                    padding: "6px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    background:
                      selectedFunction === fn.name ? "#e0f2fe" : "transparent",
                  }}
                >
                  {fn.name}
                </div>
              ))}
          </div>


          {/*CARBON FUNCTIONS */}
          <div>
            <div
              style={{ fontWeight: 600, cursor: "pointer", marginBottom: "4px" }}
              onClick={() =>
                setOpenGroup(openGroup === "carbon" ? null : "carbon")
              }
            >
              Carbon Calculation {openGroup === "carbon" ? "▾" : "▸"}
            </div>
            {openGroup === "carbon" &&
              filterFuncs(funcCarbonContent, funcSearchRef.current).map((fn) => (
                <div
                  key={fn.name}
                  onClick={() => {
                    setSelectedFunction(fn.name);
                    setSelectedFunctionGroup(openGroup);

                    console.log("createCols::14",fn.name,fn.create_cols)
                    if (fn.create_cols && Array.isArray(fn.create_cols)) {
                      setFuncColsCreateContent(prev => [
                        ...prev,
                        { [fn.name]: fn.create_cols}
                      ]);
                      console.log("createCols::15",funcColsCreateContentRef.current)
                    }
                    setIsFuncOpen(false);
                  }}
                  style={{
                    padding: "6px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    background:
                      selectedFunction === fn.name ? "#e0f2fe" : "transparent",
                  }}
                >
                  {fn.name}
                </div>
              ))}
          </div>

          {/*SQLITEFUNCTIONS */}
          <div>
            <div
              style={{ fontWeight: 600, cursor: "pointer", marginBottom: "4px" }}
              onClick={() =>
                setOpenGroup(openGroup === "sqlite" ? null : "sqlite")
              }
            >
              Sqlite Functions {openGroup === "sqlite" ? "▾" : "▸"}
            </div>
            {openGroup === "sqlite" &&
              filterFuncs(funcSqliteContent, funcSearchRef.current).map((fn) => (
                <div
                  key={fn.signature}
                  onClick={() => {
                    setSelectedFunction(fn.signature);
                    setSelectedFunctionGroup(openGroup);
                    setIsFuncOpen(false);
                  }}
                  style={{
                    padding: "6px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    background:
                      selectedFunction === fn.signature ? "#e0f2fe" : "transparent",
                  }}
                >
                  {fn.signature}
                </div>
              ))}
          </div>
          
        </div>
      )}

    </div>

    {/* APPLY MODE */}
    <div style={{ marginTop: "12px" }}>
      <label style={{ display: "block", marginTop: "4px", cursor: "pointer" }}>
        <input
          type="checkbox"
          checked={applyMode === "new"}
          onChange={(e) =>
            setApplyMode(e.target.checked ? "new" : "existing")
          }
          style={{ marginRight: "6px" }}
        />
        Create new column
      </label>
    </div>

    {/* NEW COLUMN NAME */}
    {applyMode === "new" && (
      <input
        type="text"
        placeholder="New column name"
        value={newColumnNameRef.current}
        onChange={(e) => setNewColumnName(e.target.value)}
        style={{
          marginTop: "8px",
          width: "95%",
          padding: "6px 8px",
          border: "1px solid #d1d5db",
          borderRadius: "4px",
        }}
      />
    )}

{/* EXTRA ARGUMENTS */}
<div style={{ marginTop: "10px" }}>
  <div
    style={{ cursor: "pointer", fontWeight: 600 }}
    onClick={() =>
      setExtraArgsOpenFor((prev) =>
        prev === selectedColumn ? null : selectedColumn
      )
    }
  >
    Extra Arguments {extraArgsOpenFor === selectedColumn ? "▾" : "▸"}
  </div>

  {isArgsOpen && (
    <div style={{ marginTop: "6px", display: "flex", flexDirection: "column", gap: "8px" }}>
      {(argsByColumn[selectedColumn] || []).map((arg, i) => (
        <div key={i} style={{ display: "flex", gap: "6px" }}>
          <select
            value={arg.type}
            onChange={(e) =>
              setArgsByColumn((prev) => ({
                ...prev,
                [selectedColumn]: (prev[selectedColumn] || []).map((x, idx) =>
                  idx === i ? { ...x, type: e.target.value, value: "" } : x
                ),
              }))
            }
            style={{ padding: "6px", borderRadius: "4px" }}
          >
            <option value="column">Column</option>
            <option value="value">Value</option>
          </select>

          {arg.type === "column" ? (
            <select
              value={arg.value}
              onChange={(e) =>
                setArgsByColumn((prev) => ({
                  ...prev,
                  [selectedColumn]: (prev[selectedColumn] || []).map((x, idx) =>
                    idx === i ? { ...x, value: e.target.value } : x
                  ),
                }))
              }
              style={{ flex: 1, padding: "6px", borderRadius: "4px" }}
            >
              <option value="">Select Column...</option>
              {resultCols.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              value={arg.value}
              onChange={(e) =>
                setArgsByColumn((prev) => ({
                  ...prev,
                  [selectedColumn]: (prev[selectedColumn] || []).map((x, idx) =>
                    idx === i ? { ...x, value: e.target.value } : x
                  ),
                }))
              }
              style={{ flex: 1, padding: "6px", borderRadius: "4px" }}
            />
          )}

          <button
            onClick={() =>
              setArgsByColumn((prev) => ({
                ...prev,
                [selectedColumn]: (prev[selectedColumn] || []).filter(
                  (_, idx) => idx !== i
                ),
              }))
            }
            style={{ background: "transparent", border: "none", color: "#dc2626", fontWeight: 600 }}
          >
            ✕
          </button>
        </div>
      ))}

      <button
        onClick={() =>
          setArgsByColumn((prev) => ({
            ...prev,
            [selectedColumn]: [
              ...(prev[selectedColumn] || []),
              { type: "column", value: "" },
            ],
          }))
        }
        style={{ background: "transparent", border: "none", color: "#2563eb", fontWeight: 600 }}
      >
        + Add argument
      </button>
    </div>
  )}

</div>



    {/* ACTION BUTTONS */}
    <div
      style={{
        marginTop: "16px",
        display: "flex",
        justifyContent: "flex-end",
        gap: "12px",
      }}
    >
    
    <button
        onClick={() => {
          if (!selectedColumn) {
            setErrorMessage("Column cannot be empty");
            setShowErrorMessage(true);
            return;
          }

          setColumnTransforms((prev) => {
            const updated = { ...prev };
          
            const safePrev = Array.isArray(prev?.[selectedColumn])
              ? prev[selectedColumn]
              : [];
          
            const cleanedArgs = (argsByColumn[selectedColumn] || []).filter(
              (a) => a.value !== "" && a.value != null
            );

            if (cleanedArgs.length>0) {
              setExtraArgsOpen(true)
            }
        
            if (applyMode === "existing") {
              updated[selectedColumn] = [
                ...safePrev.slice(0, -1),
                {
                  fn: selectedFunction,
                  group: selectedFunctionGroup,
                  applyMode: "existing",
                  args: cleanedArgs,
                  args_open:extraArgsOpenRef.current
                },
              ];
            } else {
              updated[selectedColumn] = [
                {
                  fn: selectedFunction,
                  sourceCol: selectedColumn,
                  group: selectedFunctionGroup,
                  newCol: newColumnNameRef.current,
                  applyMode: "new",
                  args: cleanedArgs,
                  args_open: extraArgsOpenRef.current,
                },
              ];
            }
          
            return updated;
          });
          
          
          handleSaveState(columnTransformsRef.current);
          setFunctionPanelOpen(false);
        }}
        style={{
          background: "transparent",
          border: "none",
          color: "#16a34a",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Add
      </button>

      <button
        onClick={() => setFunctionPanelOpen(false)}
        style={{
          background: "transparent",
          border: "none",
          color: "#FFA500",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Cancel
      </button>

      <button
  onClick={() => {
    if (!selectedColumn) {
      setErrorMessage("No column selected to delete");
      setShowErrorMessage(true);
      return;
    }

    setColumnTransforms((prev) => {
      const updated = { ...prev };
      delete updated[selectedColumn];
      return updated;
    });

    handleSaveState({
      ...columnTransformsRef.current,
      [selectedColumn]: undefined,
    });

    // Reset UI
    setSelectedFunction(null);
    setSelectedFunctionGroup(null);
    setArgsByColumn({});
    setFunctionPanelOpen(false);
  }}
  style={{
    background: "transparent",
    border: "none",
    color: "#dc2626",
    fontWeight: 600,
    cursor: "pointer",
    marginLeft: "12px",
  }}
>
  Delete
</button>

      
    </div>
  </div>
)}

{/* RESULT TABLE */}
<div
  style={{
    flex: 1,
    overflowY: "auto",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    backgroundColor: "#fafafa",
    marginTop: "14px"
  }}
>
  {resultCols.length > 0 ? (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "12px",
      }}
    >
  {/* TABLE HEADER */}
  <thead style={{ backgroundColor: "#f3f4f6", position: "sticky", top: 0, zIndex: 1 }}>
        <tr>
          <th
            style={{
              padding: "6px",
              borderBottom: "1px solid #e5e7eb",
              textAlign: "left",
              width: "40px",
            }}
          >
            #
          </th>

          {resultCols.map((col, i) => (
  <th
  key={i}
  onMouseDown={(e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsDragging(true);
    setDragStartCol(col);

    // Decide if drag will add or remove from selectedColumns
    setDragSelecting(!selectedColumns.includes(col));
  }}

  onMouseEnter={() => {
    if (!isDragging || !dragStartCol || dragSelecting === null) return;

    const start = colIndex(dragStartCol);
    const end = colIndex(col);
    if (start === -1 || end === -1) return;

    const [min, max] = [start, end].sort((a, b) => a - b);
    const range = resultCols.slice(min, max + 1);

    setSelectedColumns((prev) => {
      if (dragSelecting) {
        const newSet = new Set(prev);
        range.forEach((c) => newSet.add(c));
        return Array.from(newSet);
      } else {
        return prev.filter((c) => !range.includes(c));
      }
    });
  }}

  onMouseUp={() => {
    setIsDragging(false);
    setDragStartCol(null);
    setDragSelecting(null);
  }}

  onClick={(e) => {
    e.stopPropagation();

    // 🔹 Single column for Apply Function
    setSelectedColumn((prev) => (prev === col ? null : col));
    setActiveColumn(col);

    // Do NOT touch selectedColumns here
    setSelectedFunction(selectedFunctionVal);
    setSelectedNewColumn(selectedNewColVal);
    //setExtraArgs(selectedArgsVal);
  }}

  style={{
    padding: "6px",
    borderBottom: "1px solid #e5e7eb",
    cursor: "pointer",
    userSelect: "none",
    backgroundColor: selectedColumns.includes(col)
      ? "#e0f2fe"   // 🔵 drag selection
      : selectedColumn === col
      ? "#fde68a"   // 🟡 single click
      : undefined,
  }}
>
  {col}
</th>

))}

      </tr>
      </thead>

      {/* TABLE BODY */}
      <tbody>
        {resultRows.map((row, idx) => (
          <tr key={idx}>
            {/* Row index */}
            <td
              onClick={() => setIsResultModalOpen(true)}
              style={{
                padding: "4px",
                borderBottom: "1px solid #f1f5f9",
                color: "#6b7280",
                textAlign: "right",
                fontSize: "0.875rem",
              }}
            >
              {idx + 1}
            </td>

            {/* Data cells */}
            {row.map((cell, j) => (
              <td
                key={j}
                onClick={() => setIsResultModalOpen(true)}
                style={{
                  padding: "4px",
                  borderBottom: "1px solid #f1f5f9",
                  verticalAlign: "top",
                  cursor: "pointer",
                }}
              >
                {String(cell)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    !loading && (
      <p style={{ color: "#9ca3af", textAlign: "center", padding: "8px" }}>
        No results yet
      </p>
    )
  )}
  
</div>

</div>
{isResultModalOpen && (
  <div
    onClick={() => setIsResultModalOpen(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 60,
      right: 50,
      width: "90vw",
      height: "95vh",
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      padding: "20px",
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside table
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
        maxWidth: "95%",
        maxHeight: "90%",
        overflowY: "auto",
        padding: "16px",
      }}
    >
      <button
        onClick={() => setIsResultModalOpen(false)}
        style={{
          position: "absolute",
          top: "3px",
          right: "10px",
          background: "#ef4444",
          color: "white",
          border: "none",
          borderRadius: "4px",
          padding: "4px 8px",
          cursor: "pointer",
        }}
      >
        ✕ Close
      </button>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "13px",
        }}
      >
        <thead style={{ backgroundColor: "#f3f4f6", position: "sticky", top: 0, zIndex: 1 }}>
          <tr>
            {resultCols.map((col, i) => (
              <th
                key={i}
                style={{ padding: "6px", borderBottom: "1px solid #e5e7eb", textAlign: "left" }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {resultRows.map((row, idx) => (
            <tr key={idx}>
              {row.map((cell, j) => (
                <td
                  key={j}
                  style={{ padding: "4px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" }}
                >
                  {String(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

      </div>
    </div>

    {error && (
  <ErrorDialog
    open={!!error}
    onClose={() => setError(null)}
    message={error}
  />
)}


<Drawer
  anchor="right"
  open={openDoc}
  onClose={() => setOpenDoc(false)}
  >

  <div
    style={{
      width: "420px",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }}
  >

    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid #ddd"
      }}
    >

      <strong>How to use features on this page?</strong>

      <IconButton onClick={() => setOpenDoc(false)}>
        <CloseIcon />
      </IconButton>

    </div>

    {/* Markdown Content */}
    <div
      style={{
        padding: "20px",
        overflowY: "auto",
        flex: 1
      }}
    >
  <ReactMarkdown
  components={{
    img: ({ node, ...props }) => (
      <img
        src={`/docs/${props.src}`}
        alt={props.alt}
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          marginTop: "12px",
        }}
      />
    ),
  }}
  >
  {doc}
  </ReactMarkdown>
    </div>

  </div>

</Drawer>


    </div>
  );
}

export default ApplyFunctionsPage;

/*
Get the Sqlite metadata like columns and types 
Add description and save to file

*/

//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